import { I18nextProvider } from 'react-i18next';
import type { ReactNode } from 'react';
import type { i18n as I18nInstance } from 'i18next';
import { syncHtmlDir } from '../rtl';
import { resolveLocale } from '../locales';
import { useEffect } from 'react';

export interface I18nProviderProps {
  readonly i18n: I18nInstance;
  readonly children: ReactNode;
  /** Disable <html dir> sync. Set true in RN (no DOM) or in tests. */
  readonly syncDocument?: boolean;
}

export function I18nProvider({ i18n, children, syncDocument = true }: I18nProviderProps) {
  useEffect(() => {
    if (!syncDocument) return;
    const apply = () => syncHtmlDir(resolveLocale(i18n.language));
    apply();
    i18n.on('languageChanged', apply);
    return () => {
      i18n.off('languageChanged', apply);
    };
  }, [i18n, syncDocument]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
